/* eslint-disable @typescript-eslint/no-explicit-any */
// variableActions.ts
import * as types from "../actionTypes/variableActionTypes";
import { SET_LANGUAGE_VAR } from "../actionTypes/variableActionTypes";

export const setVariable = (value: any) => {
  return {
    type: SET_LANGUAGE_VAR,
    payload: value,
  };
};

export const GetLanguageDataAction = {
  STARTED: () => ({
    type: types.GET_LANGUAGES_LIST.STARTED,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_LANGUAGES_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.GET_LANGUAGES_LIST.REJECTED,
    payload: error,
  }),
};

export const setAgentLanguageDataAction = {
  STARTED: (args: any) => ({
    payload: args,
    type: types.SET_AGENT_LANGUAGE.STARTED,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_AGENT_LANGUAGE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_AGENT_LANGUAGE.REJECTED,
    payload: error,
  }),
};

export const GetIPINFOAction = {
  STARTED: () => ({
    type: types.GET_IPINFO_ACTIONTYPE.STARTED,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_IPINFO_ACTIONTYPE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.GET_IPINFO_ACTIONTYPE.REJECTED,
    payload: error,
  }),
};
